/**
 * Created by Ondra on 20.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import DateTime from '../components/numbers/DateTime';
import {isNeedArrayPrint} from '../../common/lib/util';

class KitchenPrint extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        kitchenPrintType: React.PropTypes.string,
        bar: React.PropTypes.object,
        kitchenToPrint: React.PropTypes.object,
        kitchenItemsPrintSeparate: React.PropTypes.bool,
    };

    getItemByPieces(item, id) {
        let content = [];
        for(var i = 0; i < item.get('pcs'); i++) {
            content.push(<span className={`print-item-${id}`} style={{ fontWeight: 'bold', fontSize: '20px' }}>
                        1x {item.get('name')}<br/><br/>
                        </span>);
        }
        return content;
    }

    render() {
        const {bar, kitchenToPrint, kitchenPrintType, msg, kitchenItemsPrintSeparate} = this.props;

        if (!!isNeedArrayPrint(kitchenPrintType)) {
            return null;
        }

        if (!bar || !kitchenToPrint) {
            return null;
        }

        return (
            <div id="print-receipt-kitchen" style={{display: 'none'}}>
                {msg.print.order}: {kitchenToPrint.get('number')}  <br/><br/>
                {msg.print.bar}: {bar.get('name')} <br/><br/>

                {!!kitchenToPrint.get('tableName') &&
                <span>
                    {msg.print.bill}: <span className="" style={{ fontWeight: 'bold', fontSize: '20px' }}>{kitchenToPrint.get('tableName')}</span> <br/><br/>
                </span>
                }

                <DateTime value={Date.now()}/> <br/><br/>

                <hr/>
                <br/>

                {!!kitchenToPrint.get('items') && kitchenToPrint.get('items').map((item, i) => {
                    if (kitchenItemsPrintSeparate) {
                        return this.getItemByPieces(item, i);
                    } else {
                       return <span className="" key={`print-item-${i}`} style={{fontWeight: 'bold', fontSize: '20px'}}>
                        {item.get('pcs')}x {item.get('name')}<br/><br/>
                        </span>
                    }
                }
                )}

                <hr/>
                <br/>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    bar: state.bars.get('bar'),
    kitchenToPrint: state.categories.get('kitchenToPrint'),
    kitchenPrintType: state.device.get('kitchenPrintType'),
    kitchenItemsPrintSeparate: state.device.get('kitchenItemsPrintSeparate'),
}))(KitchenPrint);



// WEBPACK FOOTER //
// ./src/browser/print/KitchenPrint.js